// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomePage_homepage__kbWis {
  position: relative;
  z-index: 1;
  display: grid;
  width: 100vw;
  height: 100vh;
  grid-template: "title1 title1 title1 title1" 20vh "logo title2 title2 title2" 20vh "contentHeaders contentArea contentArea contentArea" minmax(0, auto) "footerCompany footerAddress footerDocs footerEmail" 70px/3fr 6fr 150px 300px;
  gap: 1px;
  overflow: hidden;
  pointer-events: none;
}
.HomePage_homepage__kbWis::before {
  opacity: 0;
  content: "";
  transition: 0.3s ease all;
  position: absolute;
  left: 25%;
  top: 50%;
  width: 80%;
  height: 315px;
  background: linear-gradient(90deg, #6C00F5, #CDF305);
  pointer-events: none;
  filter: blur(120px);
}
.HomePage_homepage__kbWis .HomePage_title1Text__LxlGp, .HomePage_homepage__kbWis .HomePage_title2Text__RmeU4 {
  opacity: 0;
}
.HomePage_homepage__kbWis > * {
  padding: 20px;
  width: 100%;
  height: 100%;
  transition: 0.3s ease all;
  position: relative;
}
.HomePage_homepage__kbWis > *::before {
  bottom: -1px;
  left: 0;
  width: 0;
  height: 1px;
}
.HomePage_homepage__kbWis > *::after {
  top: 0;
  right: -1px;
  width: 1px;
  height: 0;
}
.HomePage_homepage__kbWis > *::before, .HomePage_homepage__kbWis > *::after {
  content: "";
  position: absolute;
  background-color: var(--white20);
  transition: 0.5s ease all;
}
.HomePage_homepage__kbWis.HomePage_loader1__Ju-qT > *::before {
  width: 100%;
}
.HomePage_homepage__kbWis.HomePage_loader1__Ju-qT > *::after {
  height: 100%;
}
.HomePage_homepage__kbWis.HomePage_loader2__JExiP::before {
  opacity: 0.14;
}
.HomePage_homepage__kbWis.HomePage_loader2__JExiP .HomePage_title1Text__LxlGp {
  opacity: 1;
}
.HomePage_homepage__kbWis.HomePage_loader2__JExiP .HomePage_footerCompanyText__4F6ff, .HomePage_homepage__kbWis.HomePage_loader2__JExiP .HomePage_footerAddressText__aDTMS, .HomePage_homepage__kbWis.HomePage_loader2__JExiP .HomePage_footerEmailText__cc4jH, .HomePage_homepage__kbWis.HomePage_loader2__JExiP .HomePage_footerDocsText__pcZFn {
  opacity: 1;
}
.HomePage_homepage__kbWis.HomePage_loader3__VVKxz .HomePage_title2Text__RmeU4 {
  opacity: 1;
}
.HomePage_homepage__kbWis.HomePage_loader4__HNwux {
  pointer-events: all;
}
.HomePage_homepage__kbWis.HomePage_loader4__HNwux .HomePage_title2Text__RmeU4 {
  text-shadow: 0 0 44px var(--white20);
}
.HomePage_homepage__kbWis.HomePage_loader4__HNwux .HomePage_logo__cmJtl {
  background: var(--mainColor);
}
.HomePage_homepage__kbWis.HomePage_loader4__HNwux .HomePage_logoImage__DBKts {
  opacity: 1;
}
.HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_contentHeadersInner__arFx8 {
  opacity: 1;
}
.HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_contentAreaMouse__yc\\+xY {
  opacity: 1;
}

.HomePage_title1__Slka0, .HomePage_title2__PTvFi {
  text-transform: uppercase;
  margin: 0;
}

.HomePage_title1__Slka0 {
  grid-area: title1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HomePage_title1Text__LxlGp {
  opacity: 0;
  transition: 0.3s ease all;
  text-align: center;
  font-size: clamp(30px, 8.8vw, 170px);
  margin: 0 0 -20px;
  color: var(--black);
  text-shadow: 1px 1px 0 var(--white), -1px -1px 0 var(--white), 1px -1px 0 var(--white), -1px 1px 0 var(--white);
}

.HomePage_logo__cmJtl {
  transition: 0.3s ease all;
  grid-area: logo;
  background: transparent;
  display: flex;
  justify-content: center;
  align-self: center;
}
.HomePage_logoImage__DBKts {
  width: 100%;
  max-width: 250px;
  padding: 0 20px;
  opacity: 0;
  transition: 0.3s ease all;
}

.HomePage_title2__PTvFi {
  grid-area: title2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HomePage_title2Text__RmeU4 {
  text-align: center;
  color: var(--white1);
  font-size: clamp(30px, 8.8vw, 170px);
  margin: 0 0 -30px;
  opacity: 0;
  transition: 0.3s ease all;
}

.HomePage_contentHeaders__9YHFn {
  grid-area: contentHeaders;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HomePage_contentHeadersMinify__pBCTK {
  height: calc(100% - 70px);
}
.HomePage_contentHeadersInner__arFx8 {
  opacity: 0;
  transition: 0.3s ease all;
}
.HomePage_contentHeadersDescription__2HPqB {
  margin: 0;
  color: rgba(255, 255, 255, 0.3);
  padding: 24px;
  vertical-align: middle;
  transition: 0.3s ease all;
  text-align: justify;
  font-size: clamp(14px, 1.3vw, 18px);
  font-weight: normal;
}
.HomePage_contentHeadersStep2__0nsJX {
  font-size: 120px;
  transform: rotate(-90deg);
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}
.HomePage_contentHeadersStep3__h7UxV {
  font-size: 28px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  max-width: 270px;
  margin: 0;
}

@keyframes HomePage_moveMouse__N8b-W {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}
.HomePage_contentArea__7wxXE {
  grid-area: contentArea;
  padding: 0;
}
.HomePage_contentAreaInner__xdXHv {
  overflow: hidden;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  transition: none;
}
.HomePage_contentAreaMouse__yc\\+xY {
  width: 50px;
  opacity: 0;
  transition: 0.3s ease all;
  animation: HomePage_moveMouse__N8b-W 2s 1s infinite alternate;
}
.HomePage_contentAreaMouseWrapper__261Dq {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HomePage_contentAreaList__sf5mU {
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 26px;
  margin: 0;
  padding: 45px 45px 100px;
  list-style-type: none;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.HomePage_contentAreaListWrapper__dKBjk {
  width: 100%;
  height: calc(100% - 80px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.HomePage_contentAreaList__sf5mU li {
  color: var(--white20);
  transition: 0.3s ease all;
}
.HomePage_contentAreaExpertise__lHLWv {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  flex-direction: column;
}
.HomePage_contentAreaExpertiseList__2cYuC {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template: 1fr 1fr/1fr 1fr;
  margin: 0;
  padding: 0;
}
.HomePage_contentAreaExpertiseList__2cYuC li {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: var(--white);
  gap: 30px;
  position: relative;
}
.HomePage_contentAreaExpertiseList__2cYuC li::before {
  content: "";
  position: absolute;
  top: 0;
  background-color: var(--white20);
  right: 0;
  height: 100%;
  width: 1px;
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(2)::before, .HomePage_contentAreaExpertiseList__2cYuC li:nth-child(4)::before {
  display: none;
}
.HomePage_contentAreaExpertiseList__2cYuC li::after {
  content: "";
  position: absolute;
  bottom: 0;
  background-color: var(--white20);
  left: 0;
  height: 1px;
  width: 100%;
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(3)::after, .HomePage_contentAreaExpertiseList__2cYuC li:nth-child(4)::after {
  display: none;
}
.HomePage_contentAreaExpertiseList__2cYuC li img {
  width: 40px;
}
.HomePage_contentAreaExpertiseList__2cYuC li span {
  display: inline-block;
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(1) img {
  filter: drop-shadow(0 0 14px rgba(204, 242, 7, 0.4));
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(1) span {
  text-shadow: 0 0 14px rgba(204, 242, 7, 0.4);
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(2) img {
  filter: drop-shadow(0 0 14px rgba(7, 87, 242, 0.4));
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(2) span {
  text-shadow: 0 0 14px rgba(7, 87, 242, 0.4);
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(3) img {
  filter: drop-shadow(0 0 14px rgba(242, 7, 190, 0.4));
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(3) span {
  text-shadow: 0 0 14px rgba(242, 7, 190, 0.4);
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(4) img {
  filter: drop-shadow(0 0 14px rgba(242, 162, 7, 0.4));
}
.HomePage_contentAreaExpertiseList__2cYuC li:nth-child(4) span {
  text-shadow: 0 0 14px rgba(242, 162, 7, 0.4);
}
.HomePage_contentAreaDocs__yiV2w {
  height: calc(100% - 80px);
  width: 100%;
}
.HomePage_contentAreaDocsList__1eZxx {
  list-style-type: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 0;
  height: 100%;
  padding: 0;
}
.HomePage_contentAreaDocsList__1eZxx li a {
  font-size: 17px;
  color: var(--white);
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  height: 100%;
  padding: 10px 10px 10px 30px;
  transition: 0.3s ease all;
}
.HomePage_contentAreaDocsList__1eZxx li a span {
  white-space: pre-wrap;
}
.HomePage_contentAreaDocsList__1eZxx li a img {
  width: 30px;
}

.HomePage_footerCompany__KKEQr {
  grid-area: footerCompany;
  display: flex;
  align-items: center;
  justify-content: center;
}
.HomePage_footerCompanyText__4F6ff {
  transition: 0.3s ease all;
  margin: 0;
  color: var(--white20);
  font-size: 20px;
  padding: 5px 0 0 0;
  opacity: 0;
}
.HomePage_loader2__JExiP .HomePage_footerCompanyMusic__afCpD {
  width: 10px;
  height: 10px;
  margin-right: 10px;
  background-color: var(--mainColor);
}
.HomePage_footerAddress__HvlAy {
  grid-area: footerAddress;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HomePage_footerAddressText__aDTMS {
  opacity: 0;
  transition: 0.3s ease all;
  margin: 0;
  color: var(--white20);
}
.HomePage_footerDocs__qUF09 {
  all: unset;
  grid-area: footerDocs;
  text-align: center;
  position: relative;
}
.HomePage_footerEmail__cLu9O {
  grid-area: footerEmail;
  display: flex;
  justify-content: center;
  align-items: center;
}
.HomePage_footerEmail__cLu9O, .HomePage_footerDocs__qUF09 {
  border: 1px solid transparent;
  color: rgba(255, 255, 255, 0.5);
  transition: 0.3s ease all;
}
.HomePage_footerEmailText__cc4jH, .HomePage_footerDocsText__pcZFn {
  opacity: 0;
}

.HomePage_button__sxVjE {
  position: absolute;
  color: var(--black);
  bottom: 70px;
  z-index: 3;
  opacity: 0;
  pointer-events: none;
  right: 0;
  width: 1px;
  height: 80px;
  background-color: var(--mainColor);
  font-size: 25px;
  font-family: Benzin, "sans-serif";
  font-weight: 800;
  border: none;
  padding: 0 20px;
  cursor: none;
  outline: none;
  box-shadow: none;
  text-transform: uppercase;
  transition: 0.5s ease all;
}
.HomePage_button__sxVjE.HomePage_active__KATUa {
  pointer-events: all;
  opacity: 1;
}
.HomePage_button__sxVjE:active {
  transform: scale(1.05);
  background-color: var(--white);
  box-shadow: -5px -5px 20px var(--white20);
}

@media (hover: hover) {
  .HomePage_title1__Slka0:hover {
    background: var(--white1);
  }
  .HomePage_title1__Slka0:hover .HomePage_title1Text__LxlGp {
    color: var(--white1);
    text-shadow: 1px 1px 0 var(--black), -1px -1px 0 var(--black), 1px -1px 0 var(--black), -1px 1px 0 var(--black);
  }
  .HomePage_logo__cmJtl:hover {
    background: var(--white1) !important;
  }
  .HomePage_contentArea__7wxXE.HomePage_step1__DgO8p:hover {
    background-color: rgba(255, 255, 255, 0.05);
  }
  .HomePage_contentHeaders__9YHFn:hover .HomePage_contentHeadersDescription__2HPqB {
    color: rgba(255, 255, 255, 0.5);
  }
  .HomePage_contentAreaDocsList__1eZxx li a:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  .HomePage_footerCompany__KKEQr:hover .HomePage_footerCompanyText__4F6ff, .HomePage_footerAddress__HvlAy:hover .HomePage_footerAddressText__aDTMS {
    color: rgba(255, 255, 255, 0.4);
  }
  .HomePage_footerEmail__cLu9O:hover, .HomePage_footerDocs__qUF09:hover {
    z-index: 4;
    background-color: var(--mainColor);
    color: var(--black);
    transform: scale(1.1);
    box-shadow: -5px -5px 20px rgba(0, 0, 0, 0.2);
  }
  .HomePage_button__sxVjE:hover {
    background-color: var(--white);
  }
}
@media (max-width: 1600px) {
  .HomePage_title1Text__LxlGp, .HomePage_title2Text__RmeU4 {
    font-size: clamp(30px, 8.5vw, 170px);
  }
}
@media (max-width: 1400px) {
  .HomePage_homepage__kbWis {
    grid-template: "title1 title1 title1 title1" 20vh "logo title2 title2 title2" 20vh "contentHeaders contentArea contentArea contentArea" minmax(0, auto) "footerCompany footerAddress footerDocs footerEmail" 70px/5fr 7fr 150px 300px;
  }
  .HomePage_title2Text__RmeU4 {
    font-size: clamp(30px, 8vw, 170px);
  }
  .HomePage_contentHeaders__9YHFn {
    padding: 15px;
  }
  .HomePage_contentAreaExpertiseList__2cYuC li {
    padding: 0 10px;
    gap: 15px;
    font-size: 14px;
  }
  .HomePage_contentAreaExpertiseList__2cYuC li img {
    width: 25px;
  }
  .HomePage_contentAreaExpertiseList__2cYuC li span {
    width: 200px;
  }
}
@media (max-width: 1160px) {
  .HomePage_homepage__kbWis {
    grid-template: "title1 title1 title1 title1" 15vh "logo title2 title2 title2" 15vh "contentHeaders contentArea contentArea contentArea" minmax(0, auto) "footerCompany footerAddress footerDocs footerEmail" 70px/7fr 9fr 120px 300px;
  }
  .HomePage_contentHeadersMinify__pBCTK {
    height: calc(100% - 60px);
  }
  .HomePage_contentHeadersStep2__0nsJX {
    font-size: 70px;
  }
  .HomePage_contentHeadersStep3__h7UxV {
    font-size: 22px;
    max-width: 220px;
  }
  .HomePage_contentAreaList__sf5mU {
    gap: 20px;
  }
  .HomePage_contentAreaListWrapper__dKBjk {
    height: calc(100% - 60px);
  }
  .HomePage_contentAreaList__sf5mU li {
    font-size: 20px;
  }
  .HomePage_contentAreaExpertise__lHLWv, .HomePage_contentAreaDocs__yiV2w {
    height: calc(100% - 60px);
  }
  .HomePage_button__sxVjE {
    height: 60px;
    font-size: 18px;
  }
  .HomePage_footerCompanyText__4F6ff {
    font-size: 16px;
  }
  .HomePage_footerAddressText__aDTMS {
    font-size: 14px;
  }
}
@media (max-width: 900px) {
  body {
    overflow: auto;
    overflow-x: hidden;
  }
  .HomePage_homepage__kbWis {
    padding-top: 70px;
    width: auto;
    height: 100vh;
    overflow: hidden;
    display: grid;
    grid-template: "title1" auto "title2" auto "contentHeaders" auto "contentArea" auto "footerCompany" auto "footerAddress" auto "footerDocs" auto "footerEmail" auto/auto;
  }
  .HomePage_homepage__kbWis::before {
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 50%;
    height: 50%;
    position: fixed;
    filter: none;
  }
  .HomePage_homepage__kbWis > * {
    padding: 15px;
  }
  .HomePage_homepage__kbWis > *::after {
    display: none;
  }
  .HomePage_homepage__kbWis.HomePage_loader3__VVKxz::before {
    width: 80%;
  }
  .HomePage_homepage__kbWis.HomePage_loader4__HNwux::before {
    height: 80%;
    filter: blur(50px);
  }
  .HomePage_homepage__kbWis.HomePage_loader4__HNwux .HomePage_button__sxVjE {
    transform: scale(1);
    opacity: 1;
  }
  .HomePage_homepage__kbWis.HomePage_loader4__HNwux .HomePage_contentHeadersDescription__2HPqB {
    opacity: 1;
  }
  .HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N {
    height: auto;
    overflow: hidden;
  }
  .HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_contentArea__7wxXE {
    opacity: 1;
  }
  .HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_footerCompany__KKEQr, .HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_footerAddress__HvlAy, .HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_footerEmail__cLu9O, .HomePage_homepage__kbWis.HomePage_loader5__\\+7h0N .HomePage_footerDocs__qUF09 {
    opacity: 1;
  }
  .HomePage_logo__cmJtl {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 70px;
    z-index: 2;
  }
  .HomePage_logoImage__DBKts {
    width: 100%;
    max-width: clamp(120px, 30vw, 200px);
  }
  .HomePage_title1__Slka0 {
    padding: 0;
    margin-top: 15px;
  }
  .HomePage_title1__Slka0::before {
    display: none;
  }
  .HomePage_title1Text__LxlGp {
    font-size: clamp(20px, 7.9vw, 73px);
    margin-bottom: 0;
  }
  .HomePage_title2__PTvFi {
    padding: 0;
  }
  .HomePage_title2Text__RmeU4 {
    margin-bottom: 0;
    font-size: clamp(30px, 11vw, 100px);
  }
  .HomePage_footerCompany__KKEQr {
    padding: 24px 10px 20px;
    opacity: 0;
  }
  .HomePage_footerCompany__KKEQr::before {
    display: none;
  }
  .HomePage_footerAddress__HvlAy {
    text-align: center;
    padding: 0 10px 10px;
    opacity: 0;
  }
  .HomePage_footerAddress__HvlAy::before {
    display: none;
  }
  .HomePage_footerDocs__qUF09 {
    font-size: 15px;
    opacity: 0;
    margin: 0;
    padding: 0;
  }
  .HomePage_footerDocs__qUF09::before {
    display: none;
  }
  .HomePage_footerEmail__cLu9O {
    font-size: 15px;
    opacity: 0;
    padding: 0 0 90px;
    margin: 0;
  }
  .HomePage_footerEmail__cLu9O::before {
    display: none;
  }
  .HomePage_contentHeadersDescription__2HPqB {
    padding: 60px 40px;
    font-size: clamp(16px, 3.4vw, 23px);
    opacity: 0;
  }
  .HomePage_contentHeadersStep2__0nsJX {
    transform: rotate(0);
    text-align: center;
    font-size: 76px;
    padding: 10px 0;
  }
  .HomePage_contentHeadersStep2__0nsJX::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--white20);
    transition: 0.5s ease all;
  }
  .HomePage_contentHeadersStep2__0nsJX::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: var(--white20);
    transition: 0.5s ease all;
  }
  .HomePage_contentHeadersStep3__h7UxV {
    width: 100%;
    text-align: center;
    max-width: none;
    font-size: clamp(20px, 4.5vw, 40px);
    position: relative;
    padding: 20px;
  }
  .HomePage_contentHeadersStep3__h7UxV::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
    transition: 0.5s ease all;
  }
  .HomePage_contentHeadersStep3__h7UxV::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: rgba(255, 255, 255, 0.2);
    transition: 0.5s ease all;
  }
  .HomePage_contentArea__7wxXE {
    padding: 0;
    opacity: 0;
  }
  .HomePage_contentAreaDocsList__1eZxx {
    height: auto;
    gap: 10px;
    margin: 10px 0;
  }
  .HomePage_contentAreaDocsList__1eZxx li a {
    font-size: clamp(12px, 3vw, 20px);
    padding: 20px;
    text-decoration: underline;
  }
  .HomePage_contentAreaDocsList__1eZxx li a img {
    width: clamp(30px, 3vw, 60px);
  }
  .HomePage_contentAreaInner__xdXHv {
    flex-direction: column;
  }
  .HomePage_contentAreaMouse__yc\\+xY {
    width: 40px;
  }
  .HomePage_contentAreaMouseWrapper__261Dq {
    min-height: 200px;
    height: 50vh;
    max-height: 400px;
  }
  .HomePage_contentAreaList__sf5mU {
    padding: 40px;
    overflow: auto;
    height: auto;
    gap: 30px;
  }
  .HomePage_contentAreaListWrapper__dKBjk {
    position: relative;
    height: auto;
  }
  .HomePage_contentAreaList__sf5mU li {
    color: rgba(255, 255, 255, 0.7);
    font-size: clamp(12px, 3.5vw, 20px);
  }
  .HomePage_contentAreaExpertise__lHLWv {
    height: auto;
  }
  .HomePage_contentAreaExpertiseList__2cYuC {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .HomePage_contentAreaExpertiseList__2cYuC li {
    width: 100%;
    padding: 30px 20px;
  }
  .HomePage_contentAreaExpertiseList__2cYuC li:nth-child(3)::after {
    display: block;
  }
  .HomePage_contentAreaExpertiseList__2cYuC li img {
    width: clamp(30px, 3vw, 60px);
  }
  .HomePage_contentAreaExpertiseList__2cYuC li span {
    width: auto;
    font-size: clamp(12px, 3vw, 20px);
  }
  .HomePage_contentAreaExpertiseList__2cYuC li span br {
    display: none;
  }
  .HomePage_button__sxVjE {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    opacity: 0;
    z-index: 30;
    pointer-events: all;
    transform: scale(0);
  }
}
@media (max-width: 500px) {
  .HomePage_homepage__kbWis::before {
    width: 200px;
    height: 200px;
    border-radius: 5px;
  }
  .HomePage_contentAreaMouseWrapper__261Dq {
    min-height: 250px;
    height: 40vh;
  }
  .HomePage_contentAreaDocsList__1eZxx {
    grid-template-columns: 1fr;
  }
  .HomePage_contentAreaList__sf5mU {
    padding: 40px 20px;
  }
  .HomePage_contentAreaExpertise__lHLWv li span br {
    display: block;
  }
}
@media (max-height: 800px) and (min-width: 900px) {
  .HomePage_title1Text__LxlGp {
    font-size: clamp(30px, 7.4vw, 110px);
    letter-spacing: clamp(10px, 1vw, 30px);
    margin-bottom: -15px;
  }
  .HomePage_title2Text__RmeU4 {
    letter-spacing: clamp(10px, 1.6vw, 30px);
    font-size: clamp(30px, 6.2vw, 100px);
    margin-bottom: -15px;
  }
  .HomePage_contentHeadersStep2__0nsJX {
    font-size: 60px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/HomePage/HomePage.module.scss","webpack://./src/shared/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,qOACA;EAIA,QAAA;EACA,gBAAA;EACA,oBAAA;AALF;AAOE;EACE,UAAA;ECjBF,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,oDAAA;EACA,oBAAA;EACA,mBAAA;ADaF;AADE;EACE,UAAA;AAGJ;AAAE;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;AAEJ;AAAI;EACE,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;AAEN;AACI;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AACN;AAEI;EACE,WAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;AAAN;AAMM;EACE,WAAA;AAJR;AAOM;EACE,YAAA;AALR;AAWI;EACE,aAAA;AATN;AAYI;EACE,UAAA;AAVN;AAeQ;EACE,UAAA;AAbV;AAoBI;EACE,UAAA;AAlBN;AAsBE;EACE,mBAAA;AApBJ;AAsBI;EACE,oCAAA;AApBN;AAuBI;EACE,4BAAA;AArBN;AAwBI;EACE,UAAA;AAtBN;AA2BI;EACE,UAAA;AAzBN;AA4BI;EACE,UAAA;AA1BN;;AA+BA;EACE,yBAAA;EACA,SAAA;AA5BF;;AA+BA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AA5BF;AA8BE;EACE,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,+GAAA;AA5BJ;;AAmCA;EACE,yBAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AAhCF;AAkCE;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;AAhCJ;;AAoCA;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjCF;AAmCE;EACE,kBAAA;EACA,oBAAA;EACA,oCAAA;EACA,iBAAA;EACA,UAAA;EACA,yBAAA;AAjCJ;;AAqCA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAlCF;AAoCE;EACE,yBAAA;AAlCJ;AAqCE;EACE,UAAA;EACA,yBAAA;AAnCJ;AAsCE;EACE,SAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mCAAA;EACA,mBAAA;AApCJ;AAuCE;EACE,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,SAAA;AArCJ;AAwCE;EACE,eAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,SAAA;AAtCJ;;AA0CA;EACE;IACE,wBAAA;EAvCF;EAyCA;IACE,2BAAA;EAvCF;AACF;AA0CA;EACE,sBAAA;EACA,UAAA;AAxCF;AA0CE;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAxCJ;AA2CE;EACE,WAAA;EACA,UAAA;EACA,yBAAA;EACA,6DAAA;AAzCJ;AA2CI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzCN;AA6CE;EASE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAnDJ;AAkCI;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AAhCN;AA8CI;EACE,qBAAA;EACA,yBAAA;AA5CN;AAgDE;EACE,WAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AA9CJ;AAgDI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,UAAA;AA9CN;AAgDM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA9CR;AAgDQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,gCAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AA9CV;AAkDU;EACE,aAAA;AAhDZ;AAoDQ;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;AAlDV;AAsDU;EACE,aAAA;AApDZ;AAwDQ;EACE,WAAA;AAtDV;AAyDQ;EACE,qBAAA;AAvDV;AA2DU;EACE,oDAAA;AAzDZ;AA4DU;EACE,4CAAA;AA1DZ;AA+DU;EACE,mDAAA;AA7DZ;AAgEU;EACE,2CAAA;AA9DZ;AAmEU;EACE,oDAAA;AAjEZ;AAoEU;EACE,4CAAA;AAlEZ;AAuEU;EACE,oDAAA;AArEZ;AAwEU;EACE,4CAAA;AAtEZ;AA6EE;EACE,yBAAA;EACA,WAAA;AA3EJ;AA6EI;EACE,qBAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AA3EN;AA8EQ;EACE,eAAA;EACA,mBAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;EACA,4BAAA;EACA,yBAAA;AA5EV;AA8EU;EACE,qBAAA;AA5EZ;AA+EU;EACE,WAAA;AA7EZ;;AAsFE;EACE,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAnFJ;AAqFI;EACE,yBAAA;EACA,SAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;AAnFN;AAsFI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kCAAA;AApFN;AAwFE;EACE,wBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAtFJ;AAwFI;EACE,UAAA;EACA,yBAAA;EACA,SAAA;EACA,qBAAA;AAtFN;AA0FE;EACE,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAxFJ;AA2FE;EACE,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAzFJ;AA4FE;EACE,6BAAA;EACA,+BAAA;EACA,yBAAA;AA1FJ;AA4FI;EACE,UAAA;AA1FN;;AA+FA;EACE,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,oBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,kCAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;AA5FF;AA8FE;EACE,mBAAA;EACA,UAAA;AA5FJ;AA+FE;EACE,sBAAA;EACA,8BAAA;EACA,yCAAA;AA7FJ;;AAiGA;EACE;IACE,yBAAA;EA9FF;EAgGE;IACE,oBAAA;IACA,+GAAA;EA9FJ;EAqGA;IACE,oCAAA;EAnGF;EAsGA;IACE,2CAAA;EApGF;EAuGA;IACE,+BAAA;EArGF;EAwGA;IACE,0CAAA;EAtGF;EAyGA;IACE,+BAAA;EAvGF;EA0GA;IACE,UAAA;IACA,kCAAA;IACA,mBAAA;IACA,qBAAA;IACA,6CAAA;EAxGF;EA4GE;IACE,8BAAA;EA1GJ;AACF;AA8GA;EACE;IACE,oCAAA;EA5GF;AACF;AA+GA;EACE;IACE,qOACA;EA9GF;EAoHA;IACE,kCAAA;EAlHF;EAqHA;IACE,aAAA;EAnHF;EAuHE;IACE,eAAA;IACA,SAAA;IACA,eAAA;EArHJ;EAuHI;IACE,WAAA;EArHN;EAwHI;IACE,YAAA;EAtHN;AACF;AA2HA;EACE;IACE,qOACA;EA1HF;EAiIE;IACE,yBAAA;EA/HJ;EAkIE;IACE,eAAA;EAhIJ;EAmIE;IACE,eAAA;IACA,gBAAA;EAjIJ;EAsIE;IACE,SAAA;EApIJ;EAsII;IACE,yBAAA;EApIN;EAuII;IACE,eAAA;EArIN;EAyIE;IACE,yBAAA;EAvIJ;EA2IA;IACE,YAAA;IACA,eAAA;EAzIF;EA6IE;IACE,eAAA;EA3IJ;EA8IE;IACE,eAAA;EA5IJ;AACF;AAgJA;EACE;IACE,cAAA;IACA,kBAAA;EA9IF;EAiJA;IACE,iBAAA;IACA,WAAA;IAEA,aAAA;IACA,gBAAA;IAEA,aAAA;IACA,uKACQ;EAlJV;EA2JE;IACE,SAAA;IACA,QAAA;IACA,gCAAA;IACA,UAAA;IACA,WAAA;IACA,eAAA;IACA,YAAA;EAzJJ;EA4JE;IACE,aAAA;EA1JJ;EA4JI;IACE,aAAA;EA1JN;EA8JE;IACE,UAAA;EA5JJ;EAgKI;IACE,WAAA;IACA,kBAAA;EA9JN;EAiKI;IACE,mBAAA;IACA,UAAA;EA/JN;EAkKI;IACE,UAAA;EAhKN;EAoKE;IACE,YAAA;IACA,gBAAA;EAlKJ;EAoKI;IACE,UAAA;EAlKN;EAsKM;IACE,UAAA;EApKR;EA0KA;IACE,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;EAxKF;EA0KE;IACE,WAAA;IACA,oCAAA;EAxKJ;EA4KA;IACE,UAAA;IACA,gBAAA;EA1KF;EA4KE;IACE,aAAA;EA1KJ;EA6KE;IACE,mCAAA;IACA,gBAAA;EA3KJ;EA+KA;IACE,UAAA;EA7KF;EA+KE;IACE,gBAAA;IACA,mCAAA;EA7KJ;EAkLE;IACE,uBAAA;IACA,UAAA;EAhLJ;EAkLI;IACE,aAAA;EAhLN;EAoLE;IACE,kBAAA;IACA,oBAAA;IACA,UAAA;EAlLJ;EAoLI;IACE,aAAA;EAlLN;EAsLE;IACE,eAAA;IACA,UAAA;IACA,SAAA;IACA,UAAA;EApLJ;EAsLI;IACE,aAAA;EApLN;EAwLE;IACE,eAAA;IACA,UAAA;IACA,iBAAA;IACA,SAAA;EAtLJ;EAwLI;IACE,aAAA;EAtLN;EA4LE;IACE,kBAAA;IACA,mCAAA;IACA,UAAA;EA1LJ;EA6LE;IACE,oBAAA;IACA,kBAAA;IACA,eAAA;IACA,eAAA;EA3LJ;EA6LI;IACE,WAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,gCAAA;IACA,yBAAA;EA3LN;EA8LI;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,gCAAA;IACA,yBAAA;EA5LN;EAgME;IACE,WAAA;IACA,kBAAA;IACA,eAAA;IACA,mCAAA;IACA,kBAAA;IACA,aAAA;EA9LJ;EAgMI;IACE,WAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,0CAAA;IACA,yBAAA;EA9LN;EAiMI;IACE,WAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,0CAAA;IACA,yBAAA;EA/LN;EAwMA;IACE,UAAA;IACA,UAAA;EAtMF;EAwME;IACE,YAAA;IACA,SAAA;IACA,cAAA;EAtMJ;EAwMI;IACE,iCAAA;IACA,aAAA;IACA,0BAAA;EAtMN;EAwMM;IACE,6BAAA;EAtMR;EA2ME;IACE,sBAAA;EAzMJ;EA4ME;IACE,WAAA;EA1MJ;EA4MI;IACE,iBAAA;IACA,YAAA;IACA,iBAAA;EA1MN;EA8ME;IACE,aAAA;IACA,cAAA;IACA,YAAA;IACA,SAAA;EA5MJ;EA8MI;IACE,kBAAA;IACA,YAAA;EA5MN;EA+MI;IACE,+BAAA;IACA,mCAAA;EA7MN;EAiNE;IACE,YAAA;EA/MJ;EAiNI;IACE,cAAA;IACA,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,mBAAA;EA/MN;EAiNM;IACE,WAAA;IACA,kBAAA;EA/MR;EAiNQ;IACE,cAAA;EA/MV;EAkNQ;IACE,6BAAA;EAhNV;EAmNQ;IACE,WAAA;IACA,iCAAA;EAjNV;EAmNU;IACE,aAAA;EAjNZ;EAyNA;IACE,eAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,UAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;EAvNF;AACF;AA0NA;EACE;IACE,YAAA;IACA,aAAA;IACA,kBAAA;EAxNF;EA4NE;IACE,iBAAA;IACA,YAAA;EA1NJ;EA6NE;IACE,0BAAA;EA3NJ;EA8NE;IACE,kBAAA;EA5NJ;EA+NE;IACE,cAAA;EA7NJ;AACF;AAiOA;EACE;IACE,oCAAA;IACA,sCAAA;IACA,oBAAA;EA/NF;EAkOA;IACE,wCAAA;IACA,oCAAA;IACA,oBAAA;EAhOF;EAmOA;IACE,eAAA;EAjOF;AACF","sourcesContent":["@import 'shared/styles/mixins';\n\n.homepage {\n  position: relative;\n  z-index: 1;\n  display: grid;\n  width: 100vw;\n  height: 100vh;\n  grid-template:\n  \"title1 title1 title1 title1\" 20vh\n  \"logo title2 title2 title2\" 20vh\n  \"contentHeaders contentArea contentArea contentArea\" minmax(0, auto)\n  \"footerCompany footerAddress footerDocs footerEmail\" 70px / 3fr 6fr 150px 300px;\n  gap: 1px;\n  overflow: hidden;\n  pointer-events: none;\n\n  &::before {\n    opacity: 0;\n    @include backgroundGradient\n  }\n\n  .title1Text, .title2Text {\n    opacity: 0;\n  }\n\n  & > * {\n    padding: 20px;\n    width: 100%;\n    height: 100%;\n    transition: .3s ease all;\n    position: relative;\n\n    &::before {\n      bottom: -1px;\n      left: 0;\n      width: 0;\n      height: 1px;\n    }\n\n    &::after {\n      top: 0;\n      right: -1px;\n      width: 1px;\n      height: 0;\n    }\n\n    &::before, &::after {\n      content: '';\n      position: absolute;\n      background-color: var(--white20);\n      transition: .5s ease all;\n    }\n  }\n\n  &.loader1 {\n    & > * {\n      &::before {\n        width: 100%;\n      }\n\n      &::after {\n        height: 100%;\n      }\n    }\n  }\n\n  &.loader2 {\n    &::before {\n      opacity: .14;\n    }\n\n    .title1Text {\n      opacity: 1;\n    }\n\n    .footer {\n      &Company, &Address, &Email, &Docs {\n        &Text {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  &.loader3 {\n    .title2Text {\n      opacity: 1;\n    }\n  }\n\n  &.loader4 {\n    pointer-events: all;\n\n    .title2Text {\n      text-shadow: 0 0 44px var(--white20);\n    }\n\n    .logo {\n      background: var(--mainColor);\n    }\n\n    .logoImage {\n      opacity: 1;\n    }\n  }\n\n  &.loader5 {\n    .contentHeadersInner {\n      opacity: 1;\n    }\n\n    .contentAreaMouse {\n      opacity: 1;\n    }\n  }\n}\n\n.title1, .title2 {\n  text-transform: uppercase;\n  margin: 0;\n}\n\n.title1 {\n  grid-area: title1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &Text {\n    opacity: 0;\n    transition: .3s ease all;\n    text-align: center;\n    font-size: clamp(30px, 8.8vw, 170px);\n    margin: 0 0 -20px;\n    color: var(--black);\n    text-shadow: 1px 1px 0 var(--white),\n    -1px -1px 0 var(--white),\n    1px -1px 0 var(--white),\n    -1px 1px 0 var(--white);\n  }\n}\n\n.logo {\n  transition: .3s ease all;\n  grid-area: logo;\n  background: transparent;\n  display: flex;\n  justify-content: center;\n  align-self: center;\n\n  &Image {\n    width: 100%;\n    max-width: 250px;\n    padding: 0 20px;\n    opacity: 0;\n    transition: .3s ease all;\n  }\n}\n\n.title2 {\n  grid-area: title2;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &Text {\n    text-align: center;\n    color: var(--white1);\n    font-size: clamp(30px, 8.8vw, 170px);\n    margin: 0 0 -30px;\n    opacity: 0;\n    transition: .3s ease all;\n  }\n}\n\n.contentHeaders {\n  grid-area: contentHeaders;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  &Minify {\n    height: calc(100% - 70px);\n  }\n\n  &Inner {\n    opacity: 0;\n    transition: .3s ease all;\n  }\n\n  &Description {\n    margin: 0;\n    color: rgba(#fff, .3);\n    padding: 24px;\n    vertical-align: middle;\n    transition: .3s ease all;\n    text-align: justify;\n    font-size: clamp(14px, 1.3vw, 18px);\n    font-weight: normal;\n  }\n\n  &Step2 {\n    font-size: 120px;\n    transform: rotate(-90deg);\n    color: rgba(#fff, .7);\n    margin: 0;\n  }\n\n  &Step3 {\n    font-size: 28px;\n    text-transform: uppercase;\n    color: rgba(#fff, .7);\n    max-width: 270px;\n    margin: 0;\n  }\n}\n\n@keyframes moveMouse {\n  from {\n    transform: translateY(0);\n  }\n  to {\n    transform: translateY(40px);\n  }\n}\n\n.contentArea {\n  grid-area: contentArea;\n  padding: 0;\n\n  &Inner {\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    transition: none;\n  }\n\n  &Mouse {\n    width: 50px;\n    opacity: 0;\n    transition: .3s ease all;\n    animation: moveMouse 2s 1s infinite alternate;\n\n    &Wrapper {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n\n  &List {\n    &Wrapper {\n      width: 100%;\n      height: calc(100% - 80px);\n      overflow: hidden;\n      display: flex;\n      flex-direction: column;\n    }\n\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n    font-size: 26px;\n    margin: 0;\n    padding: 45px 45px 100px;\n    list-style-type: none;\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n\n    li {\n      color: var(--white20);\n      transition: .3s ease all;\n    }\n  }\n\n  &Expertise {\n    width: 100%;\n    height: calc(100% - 80px);\n    display: flex;\n    flex-direction: column;\n\n    &List {\n      width: 100%;\n      height: 100%;\n      display: grid;\n      grid-template: 1fr 1fr / 1fr 1fr;\n      margin: 0;\n      padding: 0;\n\n      li {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 20px;\n        color: var(--white);\n        gap: 30px;\n        position: relative;\n\n        &::before {\n          content: '';\n          position: absolute;\n          top: 0;\n          background-color: var(--white20);\n          right: 0;\n          height: 100%;\n          width: 1px;\n        }\n\n        &:nth-child(2), &:nth-child(4) {\n          &::before {\n            display: none;\n          }\n        }\n\n        &::after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          background-color: var(--white20);\n          left: 0;\n          height: 1px;\n          width: 100%;\n        }\n\n        &:nth-child(3), &:nth-child(4) {\n          &::after {\n            display: none;\n          }\n        }\n\n        img {\n          width: 40px;\n        }\n\n        span {\n          display: inline-block;\n        }\n\n        &:nth-child(1) {\n          img {\n            filter: drop-shadow(0 0 14px rgba(#CCF207, .4));\n          }\n\n          span {\n            text-shadow: 0 0 14px rgba(#CCF207, .4);\n          }\n        }\n\n        &:nth-child(2) {\n          img {\n            filter: drop-shadow(0 0 14px rgba(#0757F2, .4));\n          }\n\n          span {\n            text-shadow: 0 0 14px rgba(#0757F2, .4);\n          }\n        }\n\n        &:nth-child(3) {\n          img {\n            filter: drop-shadow(0 0 14px rgba(#F207BE, .4));\n          }\n\n          span {\n            text-shadow: 0 0 14px rgba(#F207BE, .4);\n          }\n        }\n\n        &:nth-child(4) {\n          img {\n            filter: drop-shadow(0 0 14px rgba(#F2A207, .4));\n          }\n\n          span {\n            text-shadow: 0 0 14px rgba(#F2A207, .4);\n          }\n        }\n      }\n    }\n  }\n\n  &Docs {\n    height: calc(100% - 80px);\n    width: 100%;\n\n    &List {\n      list-style-type: none;\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      margin: 0;\n      height: 100%;\n      padding: 0;\n\n      li {\n        a {\n          font-size: 17px;\n          color: var(--white);\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          gap: 15px;\n          height: 100%;\n          padding: 10px 10px 10px 30px;\n          transition: .3s ease all;\n\n          span {\n            white-space: pre-wrap;\n          }\n\n          img {\n            width: 30px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.footer {\n  &Company {\n    grid-area: footerCompany;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &Text {\n      transition: .3s ease all;\n      margin: 0;\n      color: var(--white20);\n      font-size: 20px;\n      padding: 5px 0 0 0;\n      opacity: 0;\n    }\n\n    .loader2 &Music {\n      width: 10px;\n      height: 10px;\n      margin-right: 10px;\n      background-color: var(--mainColor);\n    }\n  }\n\n  &Address {\n    grid-area: footerAddress;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    &Text {\n      opacity: 0;\n      transition: .3s ease all;\n      margin: 0;\n      color: var(--white20);\n    }\n  }\n\n  &Docs {\n    all: unset;\n    grid-area: footerDocs;\n    text-align: center;\n    position: relative;\n  }\n  \n  &Email {\n    grid-area: footerEmail;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &Email, &Docs {\n    border: 1px solid transparent;\n    color: rgba(#fff, .5);\n    transition: .3s ease all;\n\n    &Text {\n      opacity: 0;\n    }\n  }\n}\n\n.button {\n  position: absolute;\n  color: var(--black);\n  bottom: 70px;\n  z-index: 3;\n  opacity: 0;\n  pointer-events: none;\n  right: 0;\n  width: 1px;\n  height: 80px;\n  background-color: var(--mainColor);\n  font-size: 25px;\n  font-family: Benzin, 'sans-serif';\n  font-weight: 800;\n  border: none;\n  padding: 0 20px;\n  cursor: none;\n  outline: none;\n  box-shadow: none;\n  text-transform: uppercase;\n  transition: .5s ease all;\n\n  &.active {\n    pointer-events: all;\n    opacity: 1;\n  }\n\n  &:active {\n    transform: scale(1.05);\n    background-color: var(--white);\n    box-shadow: -5px -5px 20px var(--white20);\n  }\n}\n\n@media (hover: hover) {\n  .title1:hover {\n    background: var(--white1);\n\n    .title1Text {\n      color: var(--white1);\n      text-shadow: 1px 1px 0 var(--black),\n      -1px -1px 0 var(--black),\n      1px -1px 0 var(--black),\n      -1px 1px 0 var(--black);\n    }\n  }\n\n  .logo:hover {\n    background: var(--white1) !important;\n  }\n\n  .contentArea.step1:hover {\n    background-color: rgba(#fff, .05);\n  }\n\n  .contentHeaders:hover .contentHeadersDescription {\n    color: rgba(#fff, .5);\n  }\n\n  .contentAreaDocsList li a:hover {\n    background-color: rgba(#fff, .1);\n  }\n\n  .footerCompany:hover .footerCompanyText, .footerAddress:hover .footerAddressText {\n    color: rgba(#fff, .4);\n  }\n\n  .footerEmail:hover, .footerDocs:hover {\n    z-index: 4;\n    background-color: var(--mainColor);\n    color: var(--black);\n    transform: scale(1.1);\n    box-shadow: -5px -5px 20px rgba(#000, .2);\n  }\n\n  .button {\n    &:hover {\n      background-color: var(--white);\n    }\n  }\n}\n\n@media(max-width: 1600px) {\n  .title1Text, .title2Text {\n    font-size: clamp(30px, 8.5vw, 170px);\n  }\n}\n\n@media(max-width: 1400px) {\n  .homepage {\n    grid-template:\n    \"title1 title1 title1 title1\" 20vh\n    \"logo title2 title2 title2\" 20vh\n    \"contentHeaders contentArea contentArea contentArea\" minmax(0, auto)\n    \"footerCompany footerAddress footerDocs footerEmail\" 70px / 5fr 7fr 150px 300px;\n  }\n\n  .title2Text {\n    font-size: clamp(30px, 8vw, 170px);\n  }\n\n  .contentHeaders {\n    padding: 15px;\n  }\n\n  .contentArea {\n    &ExpertiseList li {\n      padding: 0 10px;\n      gap: 15px;\n      font-size: 14px;\n\n      img {\n        width: 25px;\n      }\n\n      span {\n        width: 200px;\n      }\n    }\n  }\n}\n\n@media(max-width: 1160px) {\n  .homepage {\n    grid-template:\n    \"title1 title1 title1 title1\" 15vh\n    \"logo title2 title2 title2\" 15vh\n    \"contentHeaders contentArea contentArea contentArea\" minmax(0, auto)\n    \"footerCompany footerAddress footerDocs footerEmail\" 70px / 7fr 9fr 120px 300px;\n  }\n\n  .contentHeaders {\n    &Minify {\n      height: calc(100% - 60px)\n    }\n\n    &Step2 {\n      font-size: 70px;\n    }\n\n    &Step3 {\n      font-size: 22px;\n      max-width: 220px;\n    }\n  }\n\n  .contentArea {\n    &List {\n      gap: 20px;\n\n      &Wrapper {\n        height: calc(100% - 60px);\n      }\n\n      li {\n        font-size: 20px;\n      }\n    }\n\n    &Expertise, &Docs {\n      height: calc(100% - 60px);\n    }\n  }\n\n  .button {\n    height: 60px;\n    font-size: 18px;\n  }\n\n  .footer {\n    &CompanyText {\n      font-size: 16px;\n    }\n\n    &AddressText {\n      font-size: 14px;\n    }\n  }\n}\n\n@media(max-width: 900px) {\n  body {\n    overflow: auto;\n    overflow-x: hidden;\n  }\n\n  .homepage {\n    padding-top: 70px;\n    width: auto;\n\n    height: 100vh;\n    overflow: hidden;\n\n    display: grid;\n    grid-template:\n            \"title1\" auto\n    \"title2\" auto\n    \"contentHeaders\" auto\n    \"contentArea\" auto\n    \"footerCompany\" auto\n    \"footerAddress\" auto\n    \"footerDocs\" auto\n    \"footerEmail\" auto / auto;\n\n    &::before {\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 50%;\n      height: 50%;\n      position: fixed;\n      filter: none;\n    }\n\n    & > * {\n      padding: 15px;\n\n      &::after {\n        display: none;\n      }\n    }\n\n    &.loader3::before {\n      width: 80%;\n    }\n\n    &.loader4 {\n      &::before {\n        height: 80%;\n        filter: blur(50px);\n      }\n\n      .button {\n        transform: scale(1);\n        opacity: 1;\n      }\n\n      .contentHeadersDescription {\n        opacity: 1;\n      }\n    }\n\n    &.loader5 {\n      height: auto;\n      overflow: hidden;\n\n      .contentArea {\n        opacity: 1;\n      }\n\n      .footer {\n        &Company, &Address, &Email, &Docs {\n          opacity: 1;\n        }\n      }\n    }\n  }\n\n  .logo {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 70px;\n    z-index: 2;\n\n    &Image {\n      width: 100%;\n      max-width: clamp(120px, 30vw, 200px);\n    }\n  }\n\n  .title1 {\n    padding: 0;\n    margin-top: 15px;\n\n    &::before {\n      display: none;\n    }\n\n    &Text {\n      font-size: clamp(20px, 7.9vw, 73px);\n      margin-bottom: 0;\n    }\n  }\n\n  .title2 {\n    padding: 0;\n\n    &Text {\n      margin-bottom: 0;\n      font-size: clamp(30px, 11vw, 100px);\n    }\n  }\n\n  .footer {\n    &Company {\n      padding: 24px 10px 20px;\n      opacity: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    &Address {\n      text-align: center;\n      padding: 0 10px 10px;\n      opacity: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    &Docs {\n      font-size: 15px;\n      opacity: 0;\n      margin: 0;\n      padding: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n\n    &Email {\n      font-size: 15px;\n      opacity: 0;\n      padding: 0 0 90px;\n      margin: 0;\n\n      &::before {\n        display: none;\n      }\n    }\n  }\n\n  .contentHeaders {\n    &Description {\n      padding: 60px 40px;\n      font-size: clamp(16px, 3.4vw, 23px);\n      opacity: 0;\n    }\n\n    &Step2 {\n      transform: rotate(0);\n      text-align: center;\n      font-size: 76px;\n      padding: 10px 0;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 1px;\n        background-color: var(--white20);\n        transition: 0.5s ease all;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 1px;\n        background-color: var(--white20);\n        transition: 0.5s ease all;\n      }\n    }\n\n    &Step3 {\n      width: 100%;\n      text-align: center;\n      max-width: none;\n      font-size: clamp(20px, 4.5vw, 40px);\n      position: relative;\n      padding: 20px;\n\n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 1px;\n        background-color: rgba(255, 255, 255, 0.2);\n        transition: 0.5s ease all;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 1px;\n        background-color: rgba(255, 255, 255, 0.2);\n        transition: 0.5s ease all;\n      }\n    }\n  }\n\n  .contentHeadersStep4 {\n\n  }\n\n  .contentArea {\n    padding: 0;\n    opacity: 0;\n\n    &DocsList {\n      height: auto;\n      gap: 10px;\n      margin: 10px 0;\n\n      li a {\n        font-size: clamp(12px, 3vw, 20px);\n        padding: 20px;\n        text-decoration: underline;\n\n        img {\n          width: clamp(30px, 3vw, 60px);\n        }\n      }\n    }\n\n    &Inner {\n      flex-direction: column;\n    }\n\n    &Mouse {\n      width: 40px;\n\n      &Wrapper {\n        min-height: 200px;\n        height: 50vh;\n        max-height: 400px;\n      }\n    }\n\n    &List {\n      padding: 40px;\n      overflow: auto;\n      height: auto;\n      gap: 30px;\n\n      &Wrapper {\n        position: relative;\n        height: auto;\n      }\n\n      li {\n        color: rgba(#fff, .7);\n        font-size: clamp(12px, 3.5vw, 20px);\n      }\n    }\n\n    &Expertise {\n      height: auto;\n\n      &List {\n        margin: 0 auto;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n\n        li {\n          width: 100%;\n          padding: 30px 20px;\n\n          &:nth-child(3)::after {\n            display: block;\n          }\n\n          img {\n            width: clamp(30px, 3vw, 60px);\n          }\n\n          span {\n            width: auto;\n            font-size: clamp(12px, 3vw, 20px);\n\n            br {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .button {\n    position: fixed;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 60px;\n    opacity: 0;\n    z-index: 30;\n    pointer-events: all;\n    transform: scale(0);\n  }\n}\n\n@media(max-width: 500px) {\n  .homepage::before {\n    width: 200px;\n    height: 200px;\n    border-radius: 5px;\n  }\n\n  .contentArea {\n    &MouseWrapper {\n      min-height: 250px;\n      height: calc(40vh);\n    }\n\n    &DocsList {\n      grid-template-columns: 1fr;\n    }\n\n    &List {\n      padding: 40px 20px;\n    }\n\n    &Expertise li span br {\n      display: block;\n    }\n  }\n}\n\n@media(max-height: 800px) and (min-width: 900px) {\n  .title1Text {\n    font-size: clamp(30px, 7.4vw, 110px);\n    letter-spacing: clamp(10px, 1vw, 30px);\n    margin-bottom: -15px;\n  }\n\n  .title2Text {\n    letter-spacing: clamp(10px, 1.6vw, 30px);\n    font-size: clamp(30px, 6.2vw, 100px);\n    margin-bottom: -15px;\n  }\n\n  .contentHeadersStep2 {\n    font-size: 60px;\n  }\n}\n  \n","@mixin backgroundGradient() {\n  content: '';\n  transition: .3s ease all;\n  position: absolute;\n  left: 25%;\n  top: 50%;\n  width: 80%;\n  height: 315px;\n  background: linear-gradient(90deg, #6C00F5, #CDF305);\n  pointer-events: none;\n  filter: blur(120px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homepage": `HomePage_homepage__kbWis`,
	"title1Text": `HomePage_title1Text__LxlGp`,
	"title2Text": `HomePage_title2Text__RmeU4`,
	"loader1": `HomePage_loader1__Ju-qT`,
	"loader2": `HomePage_loader2__JExiP`,
	"footerCompanyText": `HomePage_footerCompanyText__4F6ff`,
	"footerAddressText": `HomePage_footerAddressText__aDTMS`,
	"footerEmailText": `HomePage_footerEmailText__cc4jH`,
	"footerDocsText": `HomePage_footerDocsText__pcZFn`,
	"loader3": `HomePage_loader3__VVKxz`,
	"loader4": `HomePage_loader4__HNwux`,
	"logo": `HomePage_logo__cmJtl`,
	"logoImage": `HomePage_logoImage__DBKts`,
	"loader5": `HomePage_loader5__+7h0N`,
	"contentHeadersInner": `HomePage_contentHeadersInner__arFx8`,
	"contentAreaMouse": `HomePage_contentAreaMouse__yc+xY`,
	"title1": `HomePage_title1__Slka0`,
	"title2": `HomePage_title2__PTvFi`,
	"contentHeaders": `HomePage_contentHeaders__9YHFn`,
	"contentHeadersMinify": `HomePage_contentHeadersMinify__pBCTK`,
	"contentHeadersDescription": `HomePage_contentHeadersDescription__2HPqB`,
	"contentHeadersStep2": `HomePage_contentHeadersStep2__0nsJX`,
	"contentHeadersStep3": `HomePage_contentHeadersStep3__h7UxV`,
	"contentArea": `HomePage_contentArea__7wxXE`,
	"contentAreaInner": `HomePage_contentAreaInner__xdXHv`,
	"moveMouse": `HomePage_moveMouse__N8b-W`,
	"contentAreaMouseWrapper": `HomePage_contentAreaMouseWrapper__261Dq`,
	"contentAreaList": `HomePage_contentAreaList__sf5mU`,
	"contentAreaListWrapper": `HomePage_contentAreaListWrapper__dKBjk`,
	"contentAreaExpertise": `HomePage_contentAreaExpertise__lHLWv`,
	"contentAreaExpertiseList": `HomePage_contentAreaExpertiseList__2cYuC`,
	"contentAreaDocs": `HomePage_contentAreaDocs__yiV2w`,
	"contentAreaDocsList": `HomePage_contentAreaDocsList__1eZxx`,
	"footerCompany": `HomePage_footerCompany__KKEQr`,
	"footerCompanyMusic": `HomePage_footerCompanyMusic__afCpD`,
	"footerAddress": `HomePage_footerAddress__HvlAy`,
	"footerDocs": `HomePage_footerDocs__qUF09`,
	"footerEmail": `HomePage_footerEmail__cLu9O`,
	"button": `HomePage_button__sxVjE`,
	"active": `HomePage_active__KATUa`,
	"step1": `HomePage_step1__DgO8p`
};
export default ___CSS_LOADER_EXPORT___;
